<ng-template #numberCellTemplate let-dataItem let-column="column">
    <div class="text-right">
        @if (column.hasDollarSign) {
            $ {{ dataItem[column.field] | number: '1.2-2' }}
        } @else {
            {{ dataItem[column.field] | number: '1.0-0' }}
        }
    </div>
</ng-template>

<ng-template #percentCellTemplate let-dataItem let-column="column">
    <div class="text-right">
        {{ dataItem[column.field] | percent:'1.6-6' }}
    </div>
</ng-template>

<ng-template #textCellTemplate let-dataItem let-column="column">
    <div>
        {{ dataItem[column.field] }}
    </div>
</ng-template>

<div class="invoice-details-header d-flex align-items-center justify-content-between pe-2" [formGroup]="invoiceForm()">
    <label for="invoice-table">Tax Saving Details:</label>
    <div class="checkbox">
        <label for="include-other">
            <input type="checkbox"
                   id="include-other"
                   data-qa="invoice-details-include-other-parcels"
                   (change)="includeOtherParcelChange($event)"
                   formControlName="includeOtherParcels" />
            Other Site
            <span>{{ constants.PropertyTypeNames[currentInvoice().propertyTypeID] }}</span>
            Parcels
        </label>
    </div>
</div>
<table class="ace-table invoice-table w-100">
    @if (!currentInvoice().isAdHoc) {
        <thead>
        <tr>
            <th helpTooltip helpContentId="invoice-details.parcelAcctNum" position="top">Parcel Acct Num</th>
            <th helpTooltip helpContentId="invoice-details.revision" position="top">Asmt Desc</th>
            @for (column of columns(); track column.field) {
                <th [ngClass]="{ 'text-right': column.alignRight }"
                    helpTooltip
                    [helpContentId]="column.helpContentId"
                    position="top">
                    {{ column.header }}
                </th>
            }
        </tr>
        </thead>
    }
    <tbody>
    <!-- APPEALS -->
        @for (taxSavings of currentInvoice().taxSavings | sortBy: 'asc': parcelName; track taxSavings.appealId) {
            @for (parcel of taxSavings.parcelSavingsCalculations; track parcel.parcelId) {
                <!--Revision Appealed-->
                @for (appeal of parcel.appealRevisionCalculations; track appeal.sequence; let first = $first; let last = $last) {
                    <tr class="delete-hover">
                        <td>
                            @if (first) {
                                <a anchor-route
                                   [isTargetBlank]="true"
                                   [sref]="{ target: 'parcel', options: { parcelId: parcel.parcelId, siteId: currentInvoice().siteId, companyId: currentInvoice().companyId }}">
                                    {{ parcel.parcelName }}
                                </a>
                            }
                        </td>
                        <td>{{ (first ? parcel.appealedRevisionDescription : '') }}</td>
                        @for (column of columns(); track column.field) {
                            <td>
                                <ng-container
                                    [ngTemplateOutlet]="column.template"
                                    [ngTemplateOutletContext]="{ $implicit: appeal, column: column, parcel: parcel }">
                                </ng-container>
                            </td>
                        }
                    </tr>
                    @if (parcel.appealRevisionCalculations.length > 1 && last) {
                        <tr class="single-column">
                            <td [attr.colspan]="columns()?.length + 1"></td>
                            <td class="text-right">
                                <span [style.color]="currentInvoice().savingsStatus">
                                    $ {{ parcel.appealRevisionCalculations | sum: 'taxAmount' | number: '1.2-2' }}
                                </span>
                            </td>
                        </tr>
                        <tr><td [attr.colspan]="columns()?.length + 2" class="spacing-row"></td></tr>
                    }
                }
                <!--Outcome Revision-->
                @for (appeal of parcel.outcomeRevisionCalculations; track appeal.sequence; let first = $first; let last = $last) {
                    <tr class="delete-hover">
                        <td></td>
                        <td>{{ (first ? parcel.outcomeRevisionDescription : '') }}</td>
                        @for (column of columns(); track column.field) {
                            <td>
                                <ng-container
                                    [ngTemplateOutlet]="column.template"
                                    [ngTemplateOutletContext]="{ $implicit: appeal, column: column, parcel: parcel }">
                                </ng-container>
                            </td>
                        }
                    </tr>
                    @if (parcel.outcomeRevisionCalculations.length > 1 && last) {
                        <tr class="single-column">
                            <td [attr.colspan]="columns()?.length + 1"></td>
                            <td class="text-right">
                                <span [style.color]="currentInvoice().savingsStatus">
                                    $ {{ parcel.outcomeRevisionCalculations | sum: 'taxAmount' | number: '1.2-2' }}
                                </span>
                            </td>
                        </tr>
                        <tr><td [attr.colspan]="columns()?.length + 2" class="spacing-row"></td></tr>
                    }
                }
                <!--Total Parcel Savings-->
                <tr>
                    <td></td>
                    @if (parcel.appealRevisionCalculations.length > 1 || parcel.outcomeRevisionCalculations.length > 1) {
                        <td [attr.colspan]="columns()?.length" class="text-end">
                            Savings {{parcel.parcelName}}:
                        </td>
                    } @else {
                        <td [attr.colspan]="columns()?.length" class="text-end">Savings</td>
                    }
                    <td class="text-right" [ngClass]="{ 'text-strike': appealRef[taxSavings.appealId]?.hasSavingsOverride }">
                        $ {{ parcel.parcelTotalSavings | number: '1.2-2' }}
                    </td>
                </tr>
                @if (appealRef[taxSavings.appealId]?.hasSavingsOverride) {
                    <tr>
                        <td [attr.colspan]="columns()?.length + 1"></td>
                        <td class="text-right text-danger">$ {{ appealRef[taxSavings.appealId]?.savingsOverride | number: '1.2-2' }}</td>
                    </tr>
                }
                <tr>
                    <td [attr.colspan]="columns()?.length + 2" class="spacing-row"></td>
                </tr>
            }
        }
        @if (!currentInvoice().isAdHoc) {
            @if (currentInvoice().includeOtherParcels) {
                <tr>
                    <td colspan="2">
                        Other Site Real Estate Parcels:
                    </td>
                    @for (column of columns(); track column.field) {
                        @if (column.field === 'marketValue') {
                            <td style="vertical-align: middle;text-align: right">
                                <span class="text-right">{{ (currentInvoice().otherParcelMV || 0) | number: '1.0-0' }}</span>
                            </td>
                        } @else if (column.field === 'taxableAssessedValue' && !currentInvoice().otherParcelHasMultipleTaxableValues) {
                            <td style="vertical-align: middle;text-align: right">
                                <span class="text-right">{{ (currentInvoice().otherParcelTaxableAV || 0) | number: '1.0-0' }}</span>
                            </td>
                        } @else {
                            <td></td>
                        }
                    }
                </tr>
            }

            <!--TOTALS-->
            @if (isMultiParcelInvoice()) {
                <tr class="single-column">
                    <td [attr.colspan]="columns()?.length + 1" class="text-right">
                        <label class="mb-0" for="total">Total Savings:</label>
                    </td>
                    <td class="text-right">
                        <span [class.calculated]="hasAnySavingsOverride">
                            $ {{ totalSavings() | number: '1.2-2' }}
                        </span>
                    </td>
                </tr>
            }
        }
    </tbody>
</table>
